/*
$(function() {
  AOS.init({
    once: true
  })
});
$(window).on('load', function() {
  AOS.refresh();
});
*/
$(document).ready(function (e) {

  (function ($) {
    'use strict';
    // call our plugin
    var Nav = new hcOffcanvasNav('#main-nav #menu-main-menu', {
      disableAt: false,
      customToggle: '.toggle',
      levelSpacing: 50,
      //navTitle: 'All Categories',
      levelTitles: true,
      levelTitleAsBack: true,
      pushContent: '#container-box',
      labelClose: false
    });

  })(jQuery);
  /*-------------*/

  if ($('#main-banner').length) {
    $('#main-banner').owlCarousel({
      autoplay: true,
      dots: true,
      nav: false,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      rewind: true,
      autoplayTimeout: 5000,
      loop: true,
      items: 1,
      margin: 0,
      responsive: {
        200: { items: 1 },
        300: { items: 1 },
        630: { items: 1 },
        980: { items: 1 }
      }
    });
  }
  if ($('#cat-slider').length) {
    $('#cat-slider').owlCarousel({
      autoplay: true,
      dots: false,
      nav: true,
      navText: ['<i class="fal fa-angle-left"></i>', '<i class="fal fa-angle-right"></i>'],
      rewind: true,
      autoplayTimeout: 5000,
      loop: true,
      items: 2,
      margin: 30,
      responsive: {
        200: { items: 1 },
        300: { items: 1, margin: 10 },
        650: { items: 2, margin: 15 },
        980: { items: 2 }
      }
    });
  }
  if ($('#hand-slider').length) {
    $('#hand-slider').owlCarousel({
      autoplay: true,
      dots: true,
      nav: false,
      navText: ['<i class="fal fa-angle-left"></i>', '<i class="fal fa-angle-right"></i>'],
      rewind: true,
      autoplayTimeout: 5000,
      loop: true,
      items: 1,
      margin: 30,
      responsive: {
        200: { items: 1 },
        300: { items: 1, margin: 10 },
        650: { items: 1, margin: 15 },
        980: { items: 1 }
      }
    });
  }
  if ($('#testi-slider').length) {
    $('#testi-slider').owlCarousel({
      autoplay: true,
      dots: false,
      nav: true,
      navText: ['<i class="fal fa-angle-left"></i>', '<i class="fal fa-angle-right"></i>'],
      rewind: true,
      autoplayTimeout: 5000,
      loop: true,
      items: 3,
      margin: 30,
      responsive: {
        200: { items: 1 },
        300: { items: 1, margin: 0 },
        767: { items: 2, margin: 15 },
        1199: { items: 3 }
      }
    });
  }
  if($('.new-products .resource-list').length){
        $('.new-products .resource-list').owlCarousel({
            autoplay:true,
            dots: false,
            nav: true,
            navText: [ '<i class="fal fa-angle-left"></i>', '<i class="fal fa-angle-right"></i>' ],
            rewind:true,
            autoplayTimeout:5000,
            loop:true,
            items:4,
            margin:20,
            responsive:{
              100:{ items:1 },
              200:{ items:2,margin:10 },
              991:{ items:3,margin:15 },
              1199:{ items:4 }
            }
        });
    }


});


